// extracted by mini-css-extract-plugin
export default {"main":"CausaPerdidoSelector_main__3KyX5"};